const RESOURCE_NAME = "entities/activityTopics";

export default {};
